import React from 'react';
interface AutoSuggestedMessagesProps {
  onSendMessage: (message: string) => void;
}
export const AutoSuggestedMessages: React.FC<AutoSuggestedMessagesProps> = ({
  onSendMessage
}) => {
  const quickReplies = ["You're so beautiful! 😍", "Can't wait to see more 💋", 'You look amazing today! 🔥', "Show me what you've got 😈"];
  return <div className="flex flex-wrap gap-2" data-id="element-2027">
      {quickReplies.map((message, index) => <button key={index} onClick={() => onSendMessage(message)} className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-full text-sm text-gray-800 dark:text-gray-200 transition-colors" data-id="element-2028">
          {message}
        </button>)}
    </div>;
};
export default AutoSuggestedMessages;